import PropTypes from 'prop-types';

import { ENV_VARS } from 'ENV_CONFIG';

export const AppointmentInformation = ({ listItem }) => (
  <ul>
    <li>
      Please aim to arrive
      <strong> 5 minutes before </strong>
      your appointment time
    </li>
    <li>
      If you have articles or photos of kitchen designs and styles that you like, please bring these
      with you
    </li>
    <li>
      Please think how you use your kitchen and what design features you want to include. This will
      help us find suitable product ranges and talk you through the options available. For
      inspiration, please visit{' '}
      <a
        href={`${ENV_VARS.REACT_APP_BROWSE_HOST}/our-services/john-lewis-fitted-kitchens`}
        target="_blank"
        rel="noopener noreferrer"
      >
        https://www.johnlewis.com/our-services/john-lewis-fitted-kitchens
      </a>
    </li>
    {listItem}
  </ul>
);

AppointmentInformation.propTypes = {
  listItem: PropTypes.node.isRequired,
};

export const RemoteAppointmentInformation = ({ listItem }) => (
  <>
    <p>
      We want to create the best kitchen for your needs, so we need to understand what design
      features you wish to include. In our virtual consultation, we can discuss our product ranges
      and talk you through the options available before your planning appointment.
    </p>
    <ul>
      <li>
        If you&apos;ve chosen a video call for your appointment, we&apos;ll send you a separate
        email link on the day of your appointment and call you
        <strong> 5 minutes before </strong>
        your appointment to check you&apos;re all set up and ready
      </li>
      <li>
        At the end of the consultation, we&apos;ll allocate your Fitted Kitchen Planner and discuss
        next steps for measuring your space, as per our&nbsp;
        <a
          href="https://static.johnlewiscontent.com/v1/static/kitchens-and-bathrooms-measuring-guide-2"
          target="_blank"
          rel="noopener noreferrer"
        >
          measuring guide
        </a>
        &nbsp;or through our in-home measure service
      </li>
      <li>
        Your allocated Fitted Kitchen Planner will arrange to plan your kitchen without visiting
        based on your measurements or will visit your home as agreed and work with you to design a
        kitchen for the space available
      </li>
      <li>
        For inspiration,&nbsp;
        <a
          href="https://www.johnlewis.com/our-services/john-lewis-fitted-kitchens"
          target="_blank"
          rel="noopener noreferrer"
        >
          view our fitted kitchens online
        </a>
        , where you can find a comprehensive range of our Fitted Kitchens and a Kitchen visualiser
        tool, as well as information regarding the end-to-end service
      </li>
      {listItem}
    </ul>
  </>
);

RemoteAppointmentInformation.propTypes = {
  listItem: PropTypes.node.isRequired,
};
